import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import FetchOnMount from '../hoc/FetchOnMount';
import WithLoader from '../hoc/WithLoader';
import categoryFilter from './hoc/categoryFilter';
import { getKioskServices, getSelectedCategories, getServices } from './selectors';

const servicesAndCategories = connect((state, ownProps) => ({
  services: ownProps.kiosk
    ? getKioskServices(state, ownProps.params.serviceId)
    : getServices(state, ownProps.params.serviceId || ownProps.selectedIds),
  categories: getSelectedCategories(state, ownProps.params.serviceId || ownProps.selectedIds),
}));

// eslint-disable-next-line import/prefer-default-export
export const commonServicesProvider = compose(
  withRouter,
  servicesAndCategories,
  FetchOnMount,
  WithLoader,
  categoryFilter,
);



// WEBPACK FOOTER //
// ./src/app/services/hoc.js